export class RouteConst {
    public static login = '/login';
    public static users = '/users';
    public static practice = '/practices';
    public static dashboard = '/dashboard';
}